'use strict';

var limitedJobListDirective = /*@ngInject*/ function() {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    scope: {},
    bindToController: {
      data: '<',
      view: '=',
      showDownload: '<',
      disableSelection: '='
    },
    controllerAs: 'job',
    controller: 'JobController',
    templateUrl: 'templates/partials/job/lists/limited.tpl.html'
  };
};

module.exports = limitedJobListDirective;
